import React from "react";
import { Link } from "react-router-dom";

import logoImg from "../../images/horizontal-logo.svg";
import useNavigationStore from "../../stores/navigationStore";
import getIframeData from "../../utils/iframe";
import CollapseButton from "./components/CollapseButton";
import DropdownItems from "./components/UserDropdown/DropdownItems";
import NavItems from "./components/UserDropdown/NavItems";
import UserDropdown from "./components/UserDropdown/UserDropdown";

const iframeData = getIframeData();

function MainSidebar() {
  const openSidebar = useNavigationStore((s) => s.openSidebar);

  return (
    <aside className={`border-end min-vh-100 d-flex flex-column justify-content-between main-sidebar ${!openSidebar ? "main-sidebar--hidden" : ""}`}>
      <div style={{ width: "22vw" }} className="main-sidebar__body p-3">
        <div className="mb-5">
          <div className="d-flex flex-column align-items-center justify-content-center gap-2">
            <Link to="/">
              <img src={logoImg} style={{ width: "70%" }} alt="Logo" />
            </Link>
            {iframeData.inIframe && (
              <div className="d-flex flex-column align-items-center justify-content-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up" viewBox="0 0 16 16">
                  <path
                    fillRule="evenodd"
                    d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"
                  />
                </svg>
                <b>YOUR LOGO HERE</b>
              </div>
            )}
          </div>
        </div>
        <div className="mb-3">
          <UserDropdown />
          <DropdownItems />
        </div>
        <NavItems />
      </div>
      <CollapseButton />
    </aside>
  );
}

export default MainSidebar;
